import React, { Component } from 'react';
import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { registerModal } from './Modals.jsx';

import actions from './actions.js';

export default function(modals = {}, CustomComponent) {
  const names = Object.keys(modals);
  //on enregistre les component modals
  names.forEach((name) => {
    registerModal(name, modals[name]);
  });

  const connectModals = class extends Component {
    constructor(props) {
      super(props);
      this.actions = bindActionCreators(actions, props.dispatch);
      this.openModals = names.reduce((obj, name) => {
        obj['open' + name] = (initialState) => this.actions.openModal({ name, initialState });
        return obj;
      }, {});
      this.closeModals = names.reduce((obj, name) => {
        obj['close' + name] = (force = false) => this.actions.closeModal({ name, force });
        return obj;
      }, {});
      this.closeModals['closeAll'] = () => this.actions.closeAllModals();

      names.forEach((name) => this.actions.registerModal(name));
    }

    componentWillUnmount() {
      names.forEach((name) => this.actions.unregisterModal(name));
    }

    render() {
      return (
        <CustomComponent {...this.props} {...this.openModals} {...this.closeModals}>
          {this.props.children}
        </CustomComponent>
      );
    }
  };

  return reduxConnect()(connectModals);
}